import { useState, useEffect } from "react";

const useActivityLogData = (page = 0, pageSize = 10, filterType = null, filterValue = null) => {
	const [activityLogsData, setActivityLogsData] = useState([]);
	const [activityLogsFilters, setActivityLogsFilters] = useState([]);
	const [isLoading, setLoading] = useState(true);
	const [activityLogsErrors, setError] = useState(null);
	const [totalRows, setTotalRows] = useState(0);

	const baseApiUrl = `${window.location.origin}/wp-json/ahg/v1`;

	useEffect(() => {
		fetchActivityLogs();
	}, [page, pageSize, filterType, filterValue]);

	useEffect(() => {
		fetchActivityLogFilter();
	}, []);

	const fetchActivityLogs = async () => {
		try {
			setLoading(true);
			setError(null);

			let url = `${baseApiUrl}/activity-log?page=${page + 1}&pageSize=${pageSize}`;

			if (filterType && filterValue) {
				switch (filterType) {
					case "fullname":
						url += `&user_id=${encodeURIComponent(filterValue)}`;
						break;
					case "action":
						url += `&action=${encodeURIComponent(filterValue)}`;
						break;
					case "date":
						url += `&start_date=${filterValue}&end_date=${filterValue}`;
						break;
				}
			}

			const response = await fetch(url, {
				method: "GET",
				headers: {
					"Content-Type": "application/json",
					"X-WP-Nonce": window.wpApiSettings.nonce,
				},
				credentials: "include",
			});

			if (response.ok) {
				const activityLogs = await response.json();
				setActivityLogsData(activityLogs);
				setTotalRows(activityLogs?.pagination?.total_rows || 0);
				setError(null);
			} else {
				const errorData = await response.json();
				setError(errorData.message || "Failed to fetch activity logs");
			}
		} catch (error) {
			setError(error.message);
		} finally {
			setLoading(false);
		}
	};

	const fetchActivityLogFilter = async () => {
		try {
			setLoading(true);
			setError(null);

			const response = await fetch(`${baseApiUrl}/activity-log/filters`, {
				method: "GET",
				headers: {
					"Content-Type": "application/json",
					"X-WP-Nonce": window.wpApiSettings.nonce,
				},
				credentials: "include",
			});

			if (response.ok) {
				const activityLogs = await response.json();
				setActivityLogsFilters(activityLogs);
				setError(null);
			} else {
				const errorData = await response.json();
				throw setError(errorData.message || "Failed to fetch activity logs filters");
			}
		} catch (error) {
			setError(error.message);
		} finally {
			setLoading(false);
		}
	};

	return {
		activityLogsData,
		activityLogsFilters,
		isLoading,
		activityLogsErrors,
		totalRows,
	};
};
export default useActivityLogData;
